import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import 'react-tabs/style/react-tabs.css';
import { toast } from 'react-toastify';

import { isEmpty } from "../../helper/helper.js"

function CourierArea({ props = {} }) {

  const [appData, setAppData] = useState({ appCodeType: 'DISTRICT' })
  const [formData, setFormData] = useState({
    mOptions: [],
    mCouriers: []
  });

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  // Custom Option component for the dropdown menu
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        {appData.appCodeType === 'DISTRICT' ?
          <div>{props.data.label} - <span className='fw-bold fs-6'>{props.data.city_name}</span> - <span className='fw-bold fs-6'>{props.data.province_name}</span></div>
          :
          <div>{props.data.label} - <span className='fw-bold fs-6'>{props.data.postalcode} - {props.data.district_name} - {props.data.city_name} - {props.data.province_name}</span> </div>
        }
      </components.Option>
    );
  };

  const loadOptions = async (inputValue, callback) => {
    let options = []
    if (inputValue.length <= 4) return
    try {
      // Simulate a delay for the API call
      await new Promise(resolve => setTimeout(resolve, 500));
      let params = {
        q: inputValue
      }

      let m
      if (appData.appCodeType === 'DISTRICT') {
        m = 'district'
      } else {
        m = 'postalcode'
      }
      const resp = await axios.get(`${window.API_HOST}/v1/courier-area-${m}`, { params })
        .then(res => {
          const resp = res.data
          options = resp.data

          callback(options)
        }).catch(err => {
          console.log(err)
        });

    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleOnChangeSelect = (option, e) => {
    if (e.action === "select-option") {
      setAppData(prevState => ({
        ...prevState,
        [e.name]: option.value,
      }))
    } else if (e.action === "clear") {
      setAppData(prevState => ({
        ...prevState,
        [e.name]: '',
      }))
    }
  }

  const onChangeAsyncSelect = async (option, e) => {
    console.log(e)
    if (e.action === "select-option") {
      if (appData.appCodeType === 'DISTRICT') {
      option = {
        ...option,
        label: `${option.label} - ${option.city_name} - ${option.province_name}`
      }
    } else {
      option = {
        ...option,
        label: `${option.value} - ${option.label} - ${option.district_name} - ${option.city_name}`
      }
    }

    setAppData(prevState => ({ ...prevState, [e.name]: option }))
    } else  if (e.action === "clear") {
      setAppData(prevState => ({ ...prevState, [e.name]: {} }))
    }
    
  }

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      type: appData.appCodeType,
      systemArea: appData.appCode?.value,
      systemAreaDescr: appData.appCode?.label,
      courier: appData.courierCode,
      courierArea: appData?.courierAreaCode,
      courierAreaDescr: appData?.courierAreaDescr,
    }

    /**
     * check / validate data 
     */

    // if (isEmpty(appData.code) || isEmpty(appData.name)) {
    //   toast.error('Code / Name is required')
    //   return
    // }

    if (!props.uid) {
      // New 
      await axios.post(`${window.API_HOST}/v1/courier-area`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          uid: resp.data.uid,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        props.uid = resp.data.uid
        toast.success(`Success save courier Area ${appData.appCode?.label}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })
    } else {

      //Update
      await axios.put(`${window.API_HOST}/v1/courier-area/${props.uid}`, payload).then(async (res) => {
        const resp = res.data

        setAppData(prevState => ({
          ...prevState,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        toast.success(`Success update courier Area ${appData.appCode?.label}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })

    }


  }

  const retrieveData = async () => {

    await axios.get(`${window.API_HOST}/v1/courier-area/${props.uid}`).then(async (res) => {
      const resp = res.data

      setAppData(prevState => ({
        ...prevState,
        appCodeType: resp?.data?.data_type,
        appCode: { value: resp?.data?.data_code, label: resp?.data?.district_name },
        type: appData.appCodeType,
        systemArea: resp?.data?.data_type,
        systemAreaDescr: resp?.data?.data_type,
        courierCode: resp?.data?.courier,
        courierAreaCode: resp?.data?.courier_area_code,
        courierAreaDescr: resp?.data?.courier_area_descr,
        updated_at: resp?.data?.updated_at,
        updated_by: resp?.data?.updated_by,
      }))

    }).catch(err => {
      toast.error(err.response.data.error)
    })

  }

  async function fetchForm() {

    await axios.get(`${window.API_HOST}/v1/courier-area/form`)
      .then(res => {
        const resp = res.data;
        setFormData(prevState => ({
          ...prevState,
          mCouriers: resp?.data?.courier ?? [],
          mTypes: [
            { value: 'DISTRICT', label: 'District' },
            { value: 'POSTALCODE', label: 'Postal Code' },
          ]
        }))

      }).catch(err => {
      })

  }

  useEffect(() => {

    //load ui data form
    fetchForm()

    if (props?.uid) {
      retrieveData()
    }

  }, [props.uid]);

  return (
    <div className='w-600px'>
      <div className='m-0 p-0' >
        <Panel>
          <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
            <div className='row'>
              <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} Courier Area</div>
              <div className='col-sm-6 align-items-baseline text-end'>
                <div className=''>
                  {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                  {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
                </div>

              </div>
            </div>
          </PanelHeader>
          <PanelBody className='p-0 m-0 pb-0 py-2'>
            <div className="row">
              <div className='col-sm-12'>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Type</label>
                  <div className="col-sm-8">
                    <Select name="appCodeType" placeholder={"Type"}
                      value={(formData.mTypes ?? []).find(({ value }) => { return value === appData.appCodeType }) ?? ''}
                      options={formData.mTypes ?? []}
                      onChange={handleOnChangeSelect}
                      isSearchable={false}
                      isDisabled={props?.uid} />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">System Area</label>
                  <div className="col-sm-8">
                    <AsyncSelect
                      name="appCode"
                      cacheOptions
                      defaultOptions
                      loadOptions={loadOptions}
                      onChange={onChangeAsyncSelect}
                      value={appData?.appCode}
                      isClearable={true}
                      components={{ Option: CustomOption }}
                      isDisabled={props?.uid}
                    />
                  </div>
                </div>
                <div className="form-group row mb-3">
                  <label className="col-sm-3 col-form-label">Courier</label>
                  <div className="col-sm-8">
                    <Select name="courierCode" placeholder={"Courier"}
                      value={(formData.mCouriers ?? []).find(({ value }) => { return value === appData.courierCode }) ?? ''}
                      options={formData.mCouriers ?? []}
                      onChange={handleOnChangeSelect}
                      isSearchable={true}
                      isDisabled={props?.uid} />
                  </div>
                </div>
                <div className="form-group row mb-0">
                  <label className="col-sm-3 col-form-label">&nbsp;</label>
                  <div className="col-sm-9">
                    <label className="col-sm-12 col-form-label">Courier Area Code</label>

                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Area Code</label>
                  <div className="col-sm-8">
                    <input type="text" name="courierAreaCode" value={appData.courierAreaCode ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Area Description</label>
                  <div className="col-sm-8">
                    <input type="text" name="courierAreaDescr" value={appData.courierAreaDescr ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" disabled={props.uid} />
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Updated By</label>
                  <div className="col-sm-8">
                    <div className='row'>
                      <div className='col-sm-6'>
                        <input type="text" value={appData.updated_by ?? ''} className="form-control form-control-sm" disabled={true} />
                      </div>
                      <div className='col-sm-6'>
                        <input type="text" value={appData.updated_at ?? ''} className="form-control form-control-sm" disabled={true} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>

  )


}

export default CourierArea